export enum EndpointsView {
  ALL = "all",
  ALL_DISCOVERED_DEVICES = "all-discovered-devices",
  ALL_EDR = "all-edr",
  ALL_ENDPOINT_MANAGEMENT = "all-endpoint-management",
  ALL_HOST_FIREWALL = "all-host-firewall",
  ALL_VULNERABILITY_MANAGEMENT = "all-vulnerability-management",
  EDR_CONTROL_FAILURES = "edr-control-failures",
  ENDPOINT_MANAGER_CONTROL_FAILURES = "endpoint-manager-control-failures",
  HOST_FIREWALL_CONTROL_FAILURES = "host-firewall-control-failures",
  MISSING_AV_POLICY = "missing-av-policy",
  MISSING_EDR_POLICY = "missing-edr-policy",
  MISSING_HOST_FIREWALL = "missing-host-firewall",
  MISSING_VULNERABILITY_AGENT = "missing-vulnerability-agent",
  MISSING_VULNERABILITY_SCAN = "missing-vulnerability-scan",
  NO_EDR = "no-edr",
  NO_ENDPOINT_MANAGER = "no-endpoint-manager",
  NO_HOST_FIREWALL = "no-host-firewall",
  NO_SERVER_MANAGER = "no-server-manager",
  NO_VULNERABILITY_MANAGER = "no-vulnerability-manager",
  NO_VULNERABILITY_SCAN = "no-vulnerability-scan",
  OUT_OF_DATE_VULNERABILITY_SCAN = "out-of-date-vulnerability-scan",
  REDUCED_FUNCTIONALITY_MODE = "reduced-functionality-mode",
  VULNERABILITY_MANAGER_CONTROL_FAILURES = "vulnerability-manager-control-failures",
}

export enum UsersView {
  ALL = "all",
  ALL_CONTROL_FAILURES = "all-control-failures",
  NO_REGISTERED_DEVICES = "no-registered-devices",
  MISSING_MFA = "missing-mfa",
}

export enum InboxesView {
  ALL = "all",
}
